import React from "react";
import { connect } from "react-redux";
import { Field, FieldType, Option } from "../../../config/Models";
import { ApplicationState } from "../../../store";
import { ToxnotComponent, ToxnotComponentProperties } from "../../core/BaseApplicationComponents/ToxnotComponent";

export interface OwnProps { summaryFields: Field[] }

export type SurveyPreviewRenderProps = ToxnotComponentProperties & OwnProps;

class CreateAndEditSurveyPreviewRenderer extends ToxnotComponent<SurveyPreviewRenderProps> {
    private getOptionDescriptions(options: Option[]) {
        return options.map(opt => opt.description);
    }

    public render(): JSX.Element | null {
        return (
            <div className="generated-survey-preview survey-questions-form-preview">
                {this.props.summaryFields.map((field, index) => {
                    return (
                        <div key={index} className="grouped-data">
                            <div className="group">
                                <div className="title">
                                    {field.label}
                                </div>
                                {(field.instructions && field.instructions !== "") && <div className="content">{field.instructions}</div>}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

// ===============================================================================

export default connect(
    // Selects which state properties are merged into the component's props
    (state: ApplicationState, ownProps: OwnProps) => ({ appServices: state.appServices })
)(CreateAndEditSurveyPreviewRenderer as any);
